export default function setupAppSizeCalculator() {
	function appSize() {
		const doc = document.documentElement;

		const getScrollbarOffset = (): number => {
			const scrollLockedContainer = document.querySelector<HTMLElement>('.SP-isScrollLocked');
			if (!scrollLockedContainer) {
				return 0;
			}
			const scrollbarOffsetRawValue = scrollLockedContainer.style
				.getPropertyValue('--scrollbarOffset')
				.match(/(\d+)px/)
				?.at(1);
			if (!scrollbarOffsetRawValue) {
				return 0;
			}
			return parseInt(scrollbarOffsetRawValue);
		};

		const resizeObserver = new ResizeObserver((entries) => {
			for (const entry of entries) {
				const { clientWidth: width, clientHeight: height } = entry.target;
				doc.style.setProperty('--app-width', `${width - getScrollbarOffset()}px`);
				doc.style.setProperty('--app-height', `${height}px`);
			}
		});

		resizeObserver.observe(doc);
	}
	appSize();
}
